module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/minimize-to-dock-c6799345f7b5981f1988f2be025d623b.svg";